import RingTreeTargetRequestAPI from '@/api/ring-tree-target-request.api'

const state = {
  requests: [],
  currentRequest: null
}

/** 
 * @type {import('vuex').GetterTree<typeof state>} 
 */
const getters = {}

/** 
 * @type {import('vuex').ActionTree<typeof state>} 
 */
const actions = {
  async createRequest({ rootGetters }, { registrationId, requestData }) {
    const accountId = rootGetters['auth/accountId']
    const response = await RingTreeTargetRequestAPI.createRequest(accountId, registrationId, requestData)
    return response
  },

  async fetchAllRequests({ commit, rootGetters }) {
    const accountId = rootGetters['auth/accountId']
    const response = await RingTreeTargetRequestAPI.getAllRequests(accountId)
    commit('SET_REQUESTS', response.data)
    return response
  },

  async fetchRequestDetails({ commit, rootGetters }, { requestId }) {
    const accountId = rootGetters['auth/accountId']
    const response = await RingTreeTargetRequestAPI.getRequestDetails(accountId, requestId)
    commit('SET_CURRENT_REQUEST', response.data)
    return response
  },

  async changeCreative({ rootGetters }, { requestId, creativeId }) {
    const accountId = rootGetters['auth/accountId']
    const response = await RingTreeTargetRequestAPI.changeCreative(accountId, requestId, creativeId)
    return response
  },

  async changeCreativeForAll({ rootGetters }, { fromCreativeId, toCreativeId }) {
    const accountId = rootGetters['auth/accountId']
    const response = await RingTreeTargetRequestAPI.changeCreativeForAll(accountId, fromCreativeId, toCreativeId)
    return response.data
  }
}

/** 
 * @type {import('vuex').MutationTree<typeof state>} 
 */
const mutations = {
  SET_REQUESTS(state, requests) {
    state.requests = requests
  },

  SET_CURRENT_REQUEST(state, request) {
    state.currentRequest = request
  },

  CLEAR_CURRENT_REQUEST(state) {
    state.currentRequest = null
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}